export default __webpack_public_path__ + "static/media/DocDuplicate.ccfa7bdd.svg";